import HeadNav from "../../components/HeadNav";
import {
  buyNFTLevel,
  contractAbiAllowance,
  contractAbiApprove,
  getDistributionConfig,
  getLevelSaleInfo,
  setUnit1
} from "../../tools/chain";
import {contractAddress} from "../../config";
import {Toast} from "vant";

export default {
  name: "buyNFT",
  components: {
    HeadNav
  },
  data() {
    return {
      showPOP: false,
      buyType: 0,
      tabIndex: '',
      value: '',
      price1: '',
      formList: [
        {
          tabIndex: 0,
          name: 'A-NFT',
          price: 300,
          sell: 0,
          total: 800
        },
        {
          tabIndex: 1,
          name: 'C-NFT',
          price: 600,
          sell: 0,
          total: 400
        },
        {
          tabIndex: 2,
          name: 'E-NFT',
          price: 1200,
          sell: 0,
          total: 200
        },
        {
          tabIndex: 3,
          name: 'S-NFT',
          price: 2400,
          sell: 0,
          total: 100
        },
      ],
      levelSaleInfo: [],
      distributionConfig: [],
    }
  },
  methods: {
    setUnit1(data) {
      return setUnit1(data)
    },
    buANFT(index) {
      this.tabIndex = index
      this.showPOP = true
      this.buyType = index + 1;
      if (index === 0) {
        this.price1 = 300
      }
      if (index === 1) {
        this.price1 = 600
      }
      if (index === 2) {
        this.price1 = 1200
      }
      if (index === 3) {
        this.price1 = 2400
      }
    },
    refresh() {
      this.getLevelSaleInfo();
      // this.getDistributionConfig();
    },
    async getLevelSaleInfo() {
      this.levelSaleInfo = await getLevelSaleInfo(this.$store.state.accounts[0]);
    },
    async getDistributionConfig() {
      this.distributionConfig = await getDistributionConfig(this.$store.state.accounts[0]);
    },
    async buyNFTLevel() {
      if (this.value === '') {
        return
      }
      let allowance = await contractAbiAllowance(contractAddress.UserContract, contractAddress.USDTToken, this.$store.state.accounts[0])
      if (allowance === 0) {
        await contractAbiApprove(contractAddress.UserContract, contractAddress.USDTToken, this.$store.state.accounts[0])
      }
      await buyNFTLevel(this.buyType, this.value);
      this.refresh();
      Toast.success({
        message: this.langUtil(87),
        onClose: () => {
          this.showPOP = false;
        }
      })
    },
  },
  mounted() {
    this.refresh();
  },

}
